module.exports = __webpack_public_path__ + "img/supplement.4c47ccb3.png";